/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNavigationUp = createReactComponent("navigation-up", "IconNavigationUp", [
  [
    "path",
    {
      d: "M16.54 12.843l-4.54 -9.843l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 22v-6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-2" }]
]);

export { IconNavigationUp as default };
//# sourceMappingURL=IconNavigationUp.js.map
